<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "CeisaMasterCustomer",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  